// src/checkout/CheckoutTabs.jsx
import * as React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const STEPS = [
  { label: "購物車", path: "/checkout/cart" },
  { label: "送貨地址與送貨訊息", path: "/checkout/address" },
  { label: "付款", path: "/checkout/payment" },
  { label: "訂單確認", path: "/checkout/confirm" },
];

export default function CheckoutTabs({ lockFuture = true }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const index = Math.max(0, STEPS.findIndex(s => pathname.startsWith(s.path)));

  return (
    <Box sx={{ mb: 3 }}>
      <Tabs
        value={index}
        onChange={(_, i) => {
          if (lockFuture && i > index) return;
          navigate(STEPS[i].path);
        }}
        variant="fullWidth"
        sx={{
          minHeight: 44,
          "& .MuiTabs-indicator": { display: "none" },
          "& .MuiTab-root": { minHeight: 44, p: 1.2 },
        }}
      >
        {STEPS.map((s, i) => (
          <Tab
            key={s.path}
            disableRipple
            label={s.label}
            sx={{
             textTransform: "none",
              fontSize: 14,
              border: "1px solid #999",
              borderRadius:
                i === 0
                  ? "4px 0 0 4px"
                  : i === STEPS.length - 1
                  ? "0 4px 4px 0"
                  : 0,
              bgcolor: index === i ? "#666" : "transparent",
              color: index === i ? "#fff" : "#000",
              fontWeight: index === i ? "bold" : "normal",
              "&.Mui-selected": {
                color: "#fff", // force white
                fontWeight: "bold", // force bold
              },
              "&:hover": { bgcolor: index === i ? "#595959" : "#f5f5f5" },
              ...(lockFuture && i > index
                ? { opacity: 0.55, cursor: "not-allowed" }
                : {}),
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
}
